export const ErrorPageConstants = {
    CREATE_DEMO_ACCOUNT_LINK: 'Create a Savvas Realize demo account',
    ERROR_MESSAGE: 'Sorry something went wrong.',
    DIRECTIONS: 'Please go back and try again.',
};
